import { EHelpTextVariant, ETextStyleVariant, HelpText, Loader, Text } from '@outdoorsyco/bonfire';
import React from 'react';

interface IDeliveryFooterMessageProps {
  message: React.ReactNode;
  loading: boolean;
  error: React.ReactNode;
}

export const DeliveryFooterMessage = ({ message, loading, error }: IDeliveryFooterMessageProps) => {
  if (loading) {
    return <Loader />;
  }
  if (error) {
    if (typeof error === 'string') {
      return <HelpText text={error} variant={EHelpTextVariant.Error} />;
    }
    return <div className="text-sm text-red-800">{error}</div>;
  }

  if (message) {
    return (
      <Text variant={ETextStyleVariant.SmallRegular} className="mb-4 md:mb-0">
        {message}
      </Text>
    );
  }

  return null;
};
